module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens23-7107e00f5d68559200e049b112e780b2.jpg";